module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "be-left-sidebar"
  }, [_vm._c('div', {
    staticClass: "left-sidebar-wrapper"
  }, [_vm._c('a', {
    staticClass: "left-sidebar-toggle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Navigation")]), _vm._v(" "), _vm._c('div', {
    staticClass: "left-sidebar-spacer"
  }, [_vm._c('div', {
    staticClass: "left-sidebar-scroll"
  }, [_vm._c('div', {
    staticClass: "left-sidebar-content"
  }, [_vm._c('ul', {
    staticClass: "sidebar-elements"
  }, [_vm._c('li', {
    staticClass: "divider"
  }, [_vm._v("Menu")]), _vm._v(" "), _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'subject-shelf'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-home"
  }), _vm._c('span', [_vm._v("Subject Shelf")])])]), _vm._v(" "), (_vm.showImport) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'importer'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-cloud-upload-alt"
  }), _vm._c('span', [_vm._v("Import Lecture Notes")])])]) : _vm._e(), _vm._v(" "), (_vm.showImport) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'exporter'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-file-export"
  }), _vm._c('span', [_vm._v("Export Lecture Notes")])])]) : _vm._e(), _vm._v(" "), (_vm.receivedShares.length > 0) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'receive-chapter'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-share-square"
  }), _vm._c('span', [_vm._v("Shared Lecture Notes")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('li', {
    staticClass: "divider"
  }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'ad-manager'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon mdi mdi-view-dashboard"
  }), _vm._c('span', [_vm._v("Manage Ads")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin || _vm.showBlogger) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'blog-manager'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-font"
  }), _vm._c('span', [_vm._v("Manage Blog")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'user-manager'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-users"
  }), _vm._c('span', [_vm._v("Manage Users")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'user-activity-report'
      },
      "tag": "li"
    }
  }, [_vm._c('a', [_vm._c('i', {
    staticClass: "icon fas fa-user-clock"
  }), _vm._c('span', [_vm._v("User Activity Report")])])]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.studyProgressPercent || _vm.totalNotesCount) ? _vm._c('div', {
    staticClass: "progress-widget"
  }, [_vm._c('div', {
    staticClass: "progress-data"
  }, [_vm._c('span', {
    staticClass: "progress-value"
  }, [_vm._v(_vm._s(_vm.completedNotesCount) + "/" + _vm._s(_vm.totalNotesCount))]), _vm._c('span', {
    staticClass: "name"
  }, [_vm._v("Study Progress")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "progress"
  }, [_vm._c('div', {
    staticClass: "progress-bar progress-bar-primary",
    class: {
      'progress-bar-success': _vm.studyProgressPercent === 100
    },
    style: ('width: ' + _vm.studyProgressPercent + '%')
  })])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21080740!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/Sidebar.vue
// module id = 632
// module chunks = 1